/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export { TestScheduler } from '../internal/testing/TestScheduler';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/testing/index.js
// module id = 784
// module chunks = 0